<div class="p-20">

  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <h2 style="text-align:center;">{{'CERTIFICARV3.TAB_PREVIEW.INST_SELECC_IDI' | translate}}</h2>
    <div fxLayout="column" fxLayoutAlign="stretch">
      <mat-form-field appearance="outline">
        <mat-label>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.ELIGELANG' | translate}}</mat-label>
        <mat-select>
          <!-- <mat-option *ngFor="let idioma of idiomasFiltrados" [value]="idioma._id" (click)="selIdiomaPreview(idioma)"> -->
          <mat-option *ngFor="let idioma of idiomasAdicionales" (click)="eligeIdiomaPreview(idioma)" [value]="idioma">
            {{'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate}}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix class="secondary-text">language</mat-icon>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>

    <!-- <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="totalTextosTraduccion == 0 && primeraSeleccion"> -->
    <!-- <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
        <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
    </div> -->

    <ng-container *ngIf="idiomaSeleccionado">
      <div *ngFor="let grupo of seccionesDemo; let idxSecc = index;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">

        <!-- <ng-container *ngIf="configTemplate.secNombresObligatorios"> -->
        <ng-container *ngFor="let langNom of grupo.sectionsLanguages; let idxLang = index;" >
          <ng-container *ngIf="langNom.lang == idiomaSeleccionado.nombreIdioma">
            <h2 *ngIf="langNom.textSection != ''">{{langNom.textSection}}</h2>
            <h2 class="colRojo" *ngIf="langNom.textSection == '' && configTemplate.secNombresObligatorios && idiomaSeleccionado.tipoIdioma == '0'">{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.FALTA' | translate}}</h2>
          </ng-container>
        </ng-container>
        <!-- </ng-container> -->
        <div *ngFor="let pregunta of grupo.questions; index as idxPreg; last as last;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">
          <ng-container *ngIf="pregunta.vivo==1">
          <mat-list>
            <ng-container *ngFor="let langPreg of pregunta.questionLanguage; let idxLang = index;">
              <ng-container *ngIf="langPreg.lang == idiomaSeleccionado.nombreIdioma">
                <h2 *ngIf="langPreg.question != ''">{{langPreg.question}}</h2>
                <h2 class="colRojo" *ngIf="langPreg.question == ''">{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.FALTA' | translate}}</h2>
              </ng-container>
            </ng-container>
            <h4 *ngIf="pregunta.answerType == 1 || pregunta.answerType == 4"><b>{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.SINGLE' | translate}}</b></h4>
            <h4 *ngIf="pregunta.answerType == 6"><b>{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.MULTI' | translate}}</b></h4>

            <ng-container *ngIf="pregunta.answerType == 2">
              <div fxLayout="column" fxLayoutAlign="stretch">
                <mat-form-field appearance="outline">
                  <mat-label>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.RESPABIERTA' | translate}}</mat-label>
                  <textarea matInput disabled></textarea>
                  <mat-error>{{'CERTIFICAR.ADICIONALES.PREVIEW.INPUT.ERRORABIERTA' | translate}}</mat-error>
                </mat-form-field>
              </div>
            </ng-container>

            <ng-container *ngIf="pregunta.answerType == 1 || pregunta.answerType == 4 || pregunta.answerType == 6">
              <ng-container *ngFor="let opcion of pregunta.answers; last as last">
                <mat-list-item *ngIf="opcion.vivo == 1">

                  <ng-container *ngIf="pregunta.answerType == 1 || pregunta.answerType == 4">
                    <mat-radio-button value="1" disabled>
                      <ng-container *ngFor="let langResp of opcion.answerLanguage; let idxLang = index;">
                        <ng-container *ngIf="langResp.lang == idiomaSeleccionado.nombreIdioma">
                          <h4 mat-line *ngIf="langResp.tag != ''">{{langResp.tag}}</h4>
                          <h4 mat-line class="colRojo" *ngIf="langResp.tag == ''">{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.FALTA' | translate}}</h4>
                        </ng-container>
                      </ng-container>
                    </mat-radio-button>
                  </ng-container>
                  <ng-container *ngIf="pregunta.answerType == 6">
                    <mat-checkbox value="1" disabled>
                      <ng-container *ngFor="let langResp of opcion.answerLanguage; let idxLang = index;">
                        <ng-container *ngIf="langResp.lang == idiomaSeleccionado.nombreIdioma">
                          <h4 mat-line *ngIf="langResp.tag != ''">{{langResp.tag}}</h4>
                          <h4 mat-line class="colRojo" *ngIf="langResp.tag == ''">{{'CERTIFICAR.ADICIONALES.PREVIEW.HELP.FALTA' | translate}}</h4>
                        </ng-container>
                      </ng-container>
                    </mat-checkbox>
                  </ng-container>

                  <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                </mat-list-item>
              </ng-container>
            </ng-container>

          </mat-list>
          </ng-container>
        </div>
      </div>
    </ng-container>


  </ng-container>

</div>
